import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const examineFlow: AppRouteModule = {
  path: '/examine-flow',
  name: 'ExamineFlow',
  component: LAYOUT,
  redirect: '/examine-flow/index',
  meta: {
    icon: 'ic:baseline-approval',
    title: '审批流程管理',
    hideChildrenInMenu: true,
    auth: 'examineFlow',
    orderNo: 50,
  },
  children: [
    {
      path: 'index',
      name: 'ExamineFlowIndex',
      component: () => import('/@/views/admin/examine-flow/index.vue'),
      meta: {
        title: '审批流程列表',
        hideMenu: true,
        ignoreKeepAlive: false,
        auth: 'examineFlow.index',
      },
    },
  ],
};

export default examineFlow;
